import React from "react";
import { Page404 } from "./Page404";

export const AboutAccessories = () => {
    return(
        <>
            <Page404 />
        </>
    )
}